import { Link } from '@inertiajs/react';
import { EditorRenderer } from '@/components/Editor';

interface HexPage {
    id: number;
    name: string;
    content?: string | null;
    order: number;
}

interface LibraryTabProps {
    currentPage: HexPage | null;
    canEdit: boolean;
    hexId: number;
    hexNameToId: Record<string, number>;
    onShowNewPageModal: () => void;
}

export function LibraryTab({
    currentPage,
    canEdit,
    hexId,
    hexNameToId,
    onShowNewPageModal,
}: LibraryTabProps) {
    if (currentPage) {
        return (
            <div className="max-w-4xl">
                {/* Page header */}
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-2xl font-bold text-white">{currentPage.name}</h2>
                    {canEdit && (
                        <Link
                            href={`/hex/${hexId}/edit?page=${currentPage.id}`}
                            className="text-sm text-purple-400 hover:text-purple-300 transition-colors"
                        >
                            Edit Page
                        </Link>
                    )}
                </div>

                {/* Page content */}
                <div className="bg-slate-800 rounded-lg p-6 border border-slate-700">
                    {currentPage.content && currentPage.content.trim() !== '' ? (
                        <EditorRenderer content={currentPage.content} hexNameToId={hexNameToId} />
                    ) : (
                        <p className="text-gray-300 italic">
                            This page is empty.{' '}
                            {canEdit && (
                                <Link
                                    href={`/hex/${hexId}/edit?page=${currentPage.id}`}
                                    className="text-purple-400 hover:text-purple-300"
                                >
                                    Add content!
                                </Link>
                            )}
                        </p>
                    )}
                </div>
            </div>
        );
    }

    // No pages exist yet - show empty state
    return (
        <div className="max-w-4xl">
            <div className="bg-slate-800 rounded-lg p-8 border border-slate-700 text-center">
                <p className="text-gray-300 mb-4">
                    This hex doesn't have any pages yet.
                </p>
                {canEdit && (
                    <button
                        onClick={onShowNewPageModal}
                        className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors"
                    >
                        Create First Page
                    </button>
                )}
            </div>
        </div>
    );
}
